import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Urls } from '../shared/Urls';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReferralForm } from '../shared/models/referral-form.model';
import { OperatorHelpers } from "../shared/helpers/operator.helpers";
import { ReferralFormQuestionGroup } from "../shared/models/referral-form-question-group.model";
import { IReferralForm } from "../shared/models/interfaces/referral-form";
import { IReferralFormType } from "../shared/models/interfaces/referral-form-type";

@Injectable({
  providedIn: 'root'
})
export class FormsService {
  constructor(private http: HttpClient) {
  }

  getAllReferralForms(): Observable<IReferralForm[]> {
    return this.http
      .get(`${Urls.getAllReferralForms}`)
      .pipe(
        map(responseData => {
          const data: IReferralForm[] = [];

          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }

  getAllReferralFormsWithoutChildren(): Observable<IReferralForm[]> {
    return this.http
      .get(`${Urls.getAllReferralFormsWithoutChildren}`)
      .pipe(
        map(responseData => {
          const data: IReferralForm[] = [];

          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }

  getReferralFormById(referralFormId: number): Observable<IReferralForm> {
    return this.http
      .get(`${Urls.getReferralFormById(referralFormId)}`)
      .pipe(
        map(responseData => {
          return responseData as IReferralForm;
        })
      );
  }
  

  getAllReferralFormTypes(): Observable<IReferralFormType[]> {
    return this.http
      .get(`${Urls.getAllReferralFormTypes}`)
      .pipe(
        map(responseData => {
          const data: IReferralFormType[] = [];

          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }

  getAllReferralFormQuestionGroups(referralFormId: number): Observable<ReferralFormQuestionGroup[]> {
    return this.http
      .get(`${Urls.getReferralFormQuestionGroups}/${referralFormId}`)
      .pipe(
        map(responseData => {
          const data: ReferralFormQuestionGroup[] = [];

          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }

  createReferralForm(referralForm: ReferralForm): Observable<IReferralForm> {
    return this.http
      .post(Urls.createReferralForm, referralForm)
      .pipe(
        map(responseData => {
          return responseData as IReferralForm;
        })
      );
  }

  updateReferralForm(referralForm: ReferralForm): Observable<IReferralForm> {
    return this.http
      .put(Urls.saveReferralForm, referralForm)
      .pipe(
        map(responseData => {
          return responseData as IReferralForm;
        })
      );
  }

  deleteReferralForm(id: number): Observable<object> {
    return this.http.delete(`${Urls.deleteReferralForm}?id=${id}`);
  }
}
